/**
 * @file Manages a custom delivery address form, calculates shipping costs using Shopify's API,
 * and adds the final address to the cart before checkout.
 * @author Your Name/Company
 * @version 2.0.0
 */

// Wrap the entire script in a single event listener to ensure the DOM is ready.
document.addEventListener("DOMContentLoaded", async () => {
  //console.log(await notifyAdmin("test2"));
  /**
   * --------------------------------------------------------------------------
   * CONFIGURATION & CONSTANTS
   * --------------------------------------------------------------------------
   * Centralized configuration for easy management of API details, selectors,
   * keys, and GraphQL queries.
   */
  const CONFIG = {
    graphQLStorefrontAPI: {
      // It's best practice to not hardcode URLs or tokens if possible,
      // but for this example, we'll keep it simple.
      url: "https://jodi-so.com/api/2025-07/graphql.json",
    },
    // generateOTP_API: {
    //   url: "https://jodiso-api-git-new-ahmad-abdelkhaleqs-projects.vercel.app/api/otp/generate",
    // },
    // verifyOTP_API: {
    //   url: "https://jodiso-api-git-new-ahmad-abdelkhaleqs-projects.vercel.app/api/otp/verify",
    // },
    storageKeys: {
      deliveryAddress: "deliveryAddress", // Key for localStorage
      paymentMethod: "paymentMethod",
    },
    css: {
      inputError: "input-error",
    },
    cart: {
      idPrefix: "gid://shopify/Cart/",
      cookieName: "cart",
    },
    country: {
      code: "JO", // Country code for Jordan
      phonePrefix: "962",
    },
    // GraphQL Queries and Mutations
    queries: {
      initialCartQuery: `
query InitialCartQuery($cartId: ID!) {
  cart(id: $cartId) {
    checkoutUrl
    cost {
      checkoutChargeAmount {
        amount
      }
      subtotalAmount {
        amount
      }
    }
    discountCodes {
      applicable
      code
    }
    discountAllocations {
      discountedAmount {
        amount
      }
      ... on CartAutomaticDiscountAllocation {
        __typename
        discountedAmount {
          amount
        }
        title
      }
      ... on CartCodeDiscountAllocation {
        __typename
        code
        discountedAmount {
          amount
        }
      }
      ... on CartCustomDiscountAllocation {
        __typename
        discountedAmount {
          amount
        }
        title
      }
    }
    delivery {
      addresses(selected: true) {
        address {
          ... on CartDeliveryAddress {
            countryCode
          }
        }
        id
        selected
        oneTimeUse
      }
    }
    deliveryGroups(first: 1) {
      nodes {
        selectedDeliveryOption {
          title
          handle
        }
        id
        deliveryOptions {
          handle
          title
          estimatedCost {
            amount
          }
        }
      }
    }
    totalQuantity
  }
}
      `,
      cartDeliveryAddressesAdd: `
mutation CartDeliveryAddressesAdd(
  $cartId: ID!
  $firstName: String
  $lastName: String
  $address1: String
  $city: String
  $zip: String
  $phone: String
) {
  cartDeliveryAddressesAdd(
    cartId: $cartId
    addresses: [
      {
        oneTimeUse: true
        selected: true
        address: {
          deliveryAddress: {
            address1: $address1
            city: $city
            countryCode: JO
            firstName: $firstName
            lastName: $lastName
            phone: $phone
            zip: $zip
          }
        }
      }
    ]
  ) {
    cart {
    id
    checkoutUrl

    }
    userErrors {
      field
      message
      code
    }
    warnings {
      code
      message
    }
  }
}
      `,
      cartDeliveryAddressUpdate: `
mutation CartDeliveryAddressesUpdate(
  $cartId: ID!
  $addressId: ID!
  $firstName: String
  $lastName: String
  $address1: String
  $city: String
  $zip: String
  $phone: String
) {
  cartDeliveryAddressesUpdate(
    cartId: $cartId
    addresses: [
      {
        id: $addressId
        oneTimeUse: true
        selected: true
        address: {
          deliveryAddress: {
            address1: $address1
            city: $city
            countryCode: JO
            firstName: $firstName
            lastName: $lastName
            phone: $phone
            zip: $zip
          }
        }
      }
    ]
  ) {
    cart {
    id
    checkoutUrl

    }
    userErrors {
      field
      message
      code
    }
    warnings {
      code
      message
    }
  }
}
      `,
      cartSelectedDeliveryOptionsUpdate: `
mutation CartSelectedDeliveryOptionsUpdate(
  $cartId: ID!
  $deliveryGroupId: ID!
  $deliveryOptionHandle: String!
) {
  cartSelectedDeliveryOptionsUpdate(
    cartId: $cartId
    selectedDeliveryOptions: [
      {
        deliveryGroupId: $deliveryGroupId
        deliveryOptionHandle: $deliveryOptionHandle
      }
    ]
  ) {
    cart {
    id
    checkoutUrl

    }
    userErrors {
      field
      message
      code
    }
  }
}
      `,
      cartDeliveryAddressesRemove: `
mutation CartDeliveryAddressesRemove($addressIds: [ID!]!, $cartId: ID!) {
  cartDeliveryAddressesRemove(addressIds: $addressIds, cartId: $cartId) {
    userErrors {
      code
      field
      message
    }
    warnings {
      code
      message
      target
    }
  }
}
      `,
      cartBuyerIdentityUpdate: `
mutation CartBuyerIdentityUpdate($cartId: ID!, $phone: String!) {
  cartBuyerIdentityUpdate(
    cartId: $cartId
    buyerIdentity: { countryCode: JO, phone: $phone }
  ) {
    cart {
      id
      checkoutUrl
  
    }
    userErrors {
      field
      message
      code
    }
  }
}
      `,
    },
  };

  /**
   * --------------------------------------------------------------------------
   * STATE MANAGEMENT
   * --------------------------------------------------------------------------
   * A single object to hold the application's state, making it easier to
   * track and debug.
   */
  const state = {
    paymentMethod: "",
    deliveryAddress: {
      name: "",
      phone: "",
      city: "",
      area: "",
    },
    allDeliveryOptions: [
      {
        handle: "bce5c20c8434043b791bde7a98028f71",
        title: "عمان / الزرقاء",
        estimatedCost: {
          amount: 2,
        },
      },
      {
        handle: "d75033fda16d57cf445ac4007a85e4ac",
        title: "باقي المحافظات",
        estimatedCost: {
          amount: 2,
        },
      },
    ], // Cache for delivery options fetched from Shopify
    matchedDeliveryOption: null,
    deliveryGroupId: null,
    deliveryAddressId: null, // Critical ID for the address we manage
    cartId: null,
    isInitializing: true,
    cartState: null,
    subtotalCost: null,
    deliveryCost: null,
    totalCost: null,
  };

  /**
   * --------------------------------------------------------------------------
   * DOM ELEMENT CACHING
   * --------------------------------------------------------------------------
   * Get all required DOM elements once and store them for performance.
   */

  const elements = () => {
    return {
      paymentRadios: document.querySelectorAll('input[name="payment_method"]'),
      paymentGroup: document.getElementById("payment_method_group"),
      nameInput: document.getElementById("address_name"),
      phoneInput: document.getElementById("address_phone"),
      citySelect: document.getElementById("address_city"),
      areaInput: document.getElementById("address_area"),
      deliveryCost: document.getElementById("delivery_cost"),
      checkoutButton: document.getElementById("checkout-with-additional-info"),
      customerData: document.getElementById(
        "customer-default-address-json-data"
      ),
      subtotalCost: document.getElementById("subtotal_cost"),
      totalCost: document.getElementById("grand_total_cost"),
      freeShipping: document.getElementById("free_shipping"),
      // phoneVerificationModal: document.getElementById(
      //   "phone_verification_modal"
      // ),
      // mainPhoneVerifiyButton: document.getElementById(
      //   "main_phone_verify_button"
      // ),
      // modalPhoneVerifyButton: document.getElementById(
      //   "modal_phone_verify_button"
      // ),
      // otpInput: document.getElementById("otp_input"),
      orderThanksModal: document.getElementById("order_thanks_modal"),
      exitButton: document.getElementById("exit_button"),
      cartItemsJson: document.getElementById("cart_items_json"),
      cartDiscountCodesJson: document.getElementById(
        "cart_discount_codes_json_without_shipping"
      ),
      // inProgressPhoneDisplay: document.getElementById(
      //   "in_progress_phone_display"
      // ),
      // failurePhoneDisplay: document.getElementById("failure_phone_display"),
      // otpSubmitPhoneDisplay: document.getElementById(
      //   "otp_submit_phone_display"
      // ),
      // sendingOtpInProgressBox: document.getElementById(
      //   "sendingOtpInProgressBox"
      // ),
      // submitOtpBox: document.getElementById("submitOtpBox"),
      // numberDontHaveWABox: document.getElementById("numberDontHaveWABox"),
      // modalPhoneVerifyRetryButton: document.getElementById(
      //   "modal_phone_verify_retry_button"
      // ),
      // modalPhoneVerifyBackButton2: document.getElementById(
      //   "modal_phone_verify_back_button_2"
      // ),
      // modalPhoneVerifyBackButton1: document.getElementById(
      //   "modal_phone_verify_back_button_1"
      // ),
      // unexpectedErrorBox: document.getElementById("unexpectedErrorBox"),
      // exitX: document.getElementById("exit_x"),
      // resendTimerText: document.getElementById("resend_timer_text"),
      // resendTimer: document.getElementById("resend_timer"),
      // resendLink: document.getElementById("resend_link"),
      // resendBox: document.getElementById("resend_box"),
      // otpSubmitCustomerServiceBox: document.getElementById(
      //   "otp_submit_customer_service_box"
      // ),
    };
  };

  const cityOptions = Array.from(elements().citySelect.options).map(
    (o) => o.value
  );

  /**
   * --------------------------------------------------------------------------
   * UTILITY FUNCTIONS
   * --------------------------------------------------------------------------
   * Helper functions for various tasks like parsing cookies and formatting numbers.
   */

  /**
   * Gets a cookie value by its name.
   * @param {string} name - The name of the cookie.
   * @returns {string|null} The cookie value or null if not found.
   */
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  };

  /**
   * Splits a full name into firstName and lastName.
   * @param {string} fullName - The full name to split.
   * @returns {{firstName: string, lastName: string}} Object with firstName and lastName.
   */
  const splitFullName = (fullName) => {
    const nameParts = fullName.trim().split(/\s+/);
    return {
      firstName: nameParts.shift() || "",
      lastName: nameParts.join(" ") || "-",
    };
  };

  /**
   * Constructs the full Shopify Cart ID from the cart cookie.
   * @returns {string|null} The full Cart GID or null if cookie is not found.
   */
  const getCartId = () => {
    try {
      const cartToken = decodeURIComponent(getCookie(CONFIG.cart.cookieName));
      return cartToken ? CONFIG.cart.idPrefix + cartToken : null;
    } catch (error) {
      console.error("Failed to get or decode cart ID cookie:", error);
      return null;
    }
  };

  /**
   * Sanitizes a phone number by removing non-numeric characters (except '+').
   * @param {string} inputString - The raw phone number string.
   * @returns {string} The sanitized phone number.
   */
  const sanitizePhoneNumber = (inputString) => {
    const arabicNumerals = /[\u0660-\u0669]/g; // Unicode range for Arabic-Indic numerals
    let convertedString = inputString.replace(
      arabicNumerals,
      (d) => d.charCodeAt(0) - 0x0660
    );
    return convertedString.replace(/[^0-9+]/g, "");
  };

  /**
   * Formats a phone number to the local Jordanian format (e.g., 07XXXXXXXX).
   * @param {string} numberString - The sanitized phone number.
   * @returns {string} The formatted phone number.
   */
  const formatPhoneNumber = (numberString) => {
    if (numberString.startsWith("+962")) return "0" + numberString.substring(4);
    if (numberString.startsWith("00962"))
      return "0" + numberString.substring(5);
    if (numberString.startsWith("962")) return "0" + numberString.substring(3);
    if (numberString.startsWith("7")) return "0" + numberString;
    return numberString;
  };

  /**
   * --------------------------------------------------------------------------
   * SHOPIFY API COMMUNICATION
   * --------------------------------------------------------------------------
   */

  /**
   * Generic function to call the Shopify GraphQL API.
   * @param {string} query - The GraphQL query or mutation string.
   * @param {object} variables - The variables for the query.
   * @returns {Promise<object|null>} The JSON response from the API or null on failure.
   */
  const callShopifyApi = async (query, variables) => {
    try {
      const response = await fetch(CONFIG.graphQLStorefrontAPI.url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          //"X-Shopify-Storefront-Access-Token": "YOUR_TOKEN_IF_NEEDED",
        },
        body: JSON.stringify({ query, variables }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const jsonResponse = await response.json();

      if (jsonResponse.errors) {
        console.error("GraphQL Errors:", jsonResponse.errors);
        return null; // Indicate a GraphQL-level error
      }

      console.log("Shopify API Response:", jsonResponse);
      return jsonResponse;
    } catch (error) {
      console.error("Error fetching from Shopify API:", error);
      elements().deliveryCost.textContent = "حدث خطأ ما";
      return null; // Indicate a network or fetch-level error
    }
  };

  /**
   * --------------------------------------------------------------------------
   * UI & FORM VALIDATION
   * --------------------------------------------------------------------------
   */

  const showError = (input, message) => {
    const errorElement = document.getElementById(`${input.id}_error`);
    if (errorElement) {
      input.classList.add(CONFIG.css.inputError);
      input.setAttribute("aria-invalid", "true");
      errorElement.textContent = message;
      errorElement.classList.add("error-mark");
    }
  };

  const clearError = (input) => {
    const errorElement = document.getElementById(`${input.id}_error`);
    if (errorElement) {
      input.classList.remove(CONFIG.css.inputError);
      input.setAttribute("aria-invalid", "false");
      errorElement.textContent = "";
      errorElement.classList.remove("error-mark");
    }
  };

  const validateCart = () => {
    const cartInvalidBox = document.getElementById("cart_is_invalid_box");
    if (cartInvalidBox) {
      console.log("cart is not valid");
      return false;
    } else {
      return true;
    }
  };

  const validateName = (showErrorUI = true) => {
    if (elements().nameInput.value.trim().length < 3) {
      showErrorUI
        ? showError(elements().nameInput, "يرجى ادخال اسم صحيح")
        : null;
      return false;
    }
    clearError(elements().nameInput);
    return true;
  };

  const validatePhone = (showErrorUI = true) => {
    const phone = elements().phoneInput.value;
    if (phone.length !== 10) {
      showErrorUI
        ? showError(elements().phoneInput, "يرجى ادخال رقم موبايل صحيح")
        : null;
      return false;
    }
    if (!/^(079|077|078)\d{7}$/.test(phone)) {
      showErrorUI
        ? showError(
          elements().phoneInput,
          "يرجى ادخال رقم موبايل صحيح يبدأ بـ 079 او 077 او 078"
        )
        : null;
      return false;
    }
    clearError(elements().phoneInput);
    return true;
  };

  const validateCity = (showErrorUI = true) => {
    if (elements().citySelect.value === "no input") {
      showErrorUI
        ? showError(elements().citySelect, "يرجى اختيار المدينة")
        : null;
      return false;
    }
    if (!cityOptions.includes(elements().citySelect.value)) {
      showErrorUI
        ? showError(elements().citySelect, "يرجى اختيار المدينة")
        : null;
      return false;
    }
    clearError(elements().citySelect);
    return true;
  };

  const validateArea = (showErrorUI = true) => {
    if (elements().areaInput.value.trim().length < 3) {
      showErrorUI
        ? showError(elements().areaInput, "يرجى ادخال اسم منطقة صحيح")
        : null;
      return false;
    }
    clearError(elements().areaInput);
    return true;
  };

  const validatePaymentMethod = (showErrorUI = true) => {
    const isSelected = Array.from(elements().paymentRadios).some(r => r.checked);
    const errorElement = document.getElementById(`payment_method_error`);

    if (!isSelected) {
      if (showErrorUI) {
        elements().paymentGroup.classList.add(CONFIG.css.inputError);
        if (errorElement) {
          errorElement.textContent = "يرجى اختيار طريقة الدفع";
          errorElement.classList.add("error-mark");
        }
      }
      return false;
    }

    elements().paymentGroup.classList.remove(CONFIG.css.inputError);
    if (errorElement) {
      errorElement.textContent = "";
      errorElement.classList.remove("error-mark");
    }
    return true;
  };

  const validateAll = () => {
    // Sequentially call validators, ensuring all are run to show all errors.
    const isCartValid = validateCart();
    const isNameValid = validateName();
    const isPhoneValid = validatePhone();
    const isCityValid = validateCity();
    const isAreaValid = validateArea();
    const isPaymentValid = validatePaymentMethod();
    return (
      isNameValid && isPhoneValid && isCityValid && isAreaValid && isCartValid && isPaymentValid
    );
  };

  const setButtonState = (disabled, text) => {
    elements().checkoutButton.disabled = disabled;
    elements().checkoutButton.querySelector("span").textContent = text;
    if (disabled) {
      elements()
        .checkoutButton.querySelector(".loading__spinner")
        .classList.remove("hidden");
    } else {
      elements()
        .checkoutButton.querySelector(".loading__spinner")
        .classList.add("hidden");
    }
  };

  /**
   *
   * Updates the displayed delivery cost based on the selected city
   * using the cached delivery options.
   */

  const UpdateMatchedDeliveryOption = () => {
    state.matchedDeliveryOption = state.allDeliveryOptions.find((opt) =>
      opt.title.includes(elements().citySelect.value)
    );

    // If no specific city match, find the fallback option (e.g., "Other Governorates")
    if (!state.matchedDeliveryOption) {
      state.matchedDeliveryOption = state.allDeliveryOptions.find((opt) =>
        opt.title.includes("باقي")
      );
    }
  };

  const formatToDinar = (numberString) => {
    // 1. Convert the string to a number. Use parseFloat to handle decimals.
    //    If the input might be invalid (e.g., "abc"), provide a fallback of 0.
    const number = parseFloat(numberString) || 0;

    // 2. Format the number to exactly two decimal places. This returns a string.
    const fixedNumber = number.toFixed(2);

    // 3. Concatenate with the currency string using a template literal.
    return `${fixedNumber} دينار`;
  };

  const updateDeliveryCostUI = () => {
    if (
      state.isInitializing ||
      !validateCity(false) ||
      state.allDeliveryOptions.length === 0
    ) {
      elements().deliveryCost.textContent = "اختار المدينة";
      return;
    }
    // console.log(state.cartState?.data?.cart?.cost?.subtotalAmount?.amount);
    UpdateMatchedDeliveryOption();
    state.subtotalCost =
      +elements().subtotalCost.getAttribute("data-subtotal-cost") / 100;
    state.deliveryCost = +state.matchedDeliveryOption.estimatedCost.amount;
    if (state.subtotalCost >= 1000) state.deliveryCost = 0;
    if (elements().freeShipping.dataset.freeShipping == "true")
      state.deliveryCost = 0;
    state.totalCost = state.subtotalCost + state.deliveryCost;

    elements().deliveryCost.textContent = state.matchedDeliveryOption
      ? formatToDinar(state.deliveryCost)
      : "N/A";
    if (elements().freeShipping.dataset.freeShipping == "true") {
      elements().deliveryCost.insertAdjacentHTML(
        "afterbegin",
        '<span class="original-total-price">2.00 </span>'
      );
    }

    elements().totalCost.textContent = state.matchedDeliveryOption
      ? formatToDinar(state.totalCost)
      : "N/A";
    document.getElementById("order_thanks_total").textContent =
      state.matchedDeliveryOption ? formatToDinar(state.totalCost) : "N/A";
  };

  /**
   * --------------------------------------------------------------------------
   * APPLICATION LOGIC & INITIALIZATION
   * --------------------------------------------------------------------------
   */

  /**
   * Loads the delivery address from localStorage or from the customer's
   * default Shopify address if localStorage is empty.
   */
  const loadInitialAddress = () => {
    let loadedAddress = null;
    try {
      const storedAddress = localStorage.getItem(
        CONFIG.storageKeys.deliveryAddress
      );
      if (storedAddress) {
        loadedAddress = JSON.parse(storedAddress);
      }
    } catch (e) {
      console.error("Could not parse address from localStorage.", e);
      localStorage.removeItem(CONFIG.storageKeys.deliveryAddress);
    }

    // If localStorage is empty, try using the default customer address
    if (!loadedAddress || Object.values(loadedAddress).every((v) => !v)) {
      try {
        const customerDefaultAddress = JSON.parse(
          elements().customerData.textContent
        );
        if (customerDefaultAddress) {
          loadedAddress = {
            name: customerDefaultAddress.name || "",
            phone: customerDefaultAddress.phone || "",
            city: (customerDefaultAddress.city || "").trim(),
            area: customerDefaultAddress.address1 || "",
          };
        }
      } catch (e) {
        // No customer data or it's invalid, which is fine for guests.
        console.log("No valid customer default address found.");
      }
    }

    // Update state and save to localStorage
    if (loadedAddress) {
      state.deliveryAddress = loadedAddress;
      localStorage.setItem(
        CONFIG.storageKeys.deliveryAddress,
        JSON.stringify(state.deliveryAddress)
      );
    }

    const loadedPaymentMethod = localStorage.getItem(CONFIG.storageKeys.paymentMethod);
    if (loadedPaymentMethod) {
      state.paymentMethod = loadedPaymentMethod;
    }
  };

  /**
   * Sets checkout button text dynamically based on the payment method
   */
  const updateCheckoutButtonText = () => {
    const textSpan = elements().checkoutButton.querySelector("span");
    if (state.paymentMethod === "cod") {
      textSpan.textContent = "ارسال الطلب";
    } else if (state.paymentMethod === "electronic") {
      textSpan.textContent = "المتابعة للدفع";
    }
  };

  /**
   * Populates the form fields with data from the state.
   */
  const populateFormFields = () => {
    elements().nameInput.value = state.deliveryAddress.name || "";
    document.getElementById("order_thanks_name").textContent =
      elements().nameInput.value;
    elements().phoneInput.value = state.deliveryAddress.phone || "";
    elements().areaInput.value = state.deliveryAddress.area || "";

    // Safely set the city select value
    if (cityOptions.includes(state.deliveryAddress.city)) {
      elements().citySelect.value = state.deliveryAddress.city;
    }

    if (state.paymentMethod) {
      const selectedRadio = Array.from(elements().paymentRadios).find(r => r.value === state.paymentMethod);
      if (selectedRadio) {
        selectedRadio.checked = true;
        updateCheckoutButtonText();
      }
    }
  };

  /**
   * Sets up all the event listeners for the form inputs.
   */
  const setupEventListenersForRerenderedElements = () => {
    elements().citySelect.addEventListener("change", () => {
      if (validateCity()) {
        state.deliveryAddress.city = elements().citySelect.value;
        localStorage.setItem(
          CONFIG.storageKeys.deliveryAddress,
          JSON.stringify(state.deliveryAddress)
        );
      }
      updateDeliveryCostUI(); // Uses cached data, no API call
    });
  };
  const setupEventListenersForStaticElements = () => {
    elements().phoneInput.addEventListener("input", () => {
      elements().phoneInput.value = sanitizePhoneNumber(
        elements().phoneInput.value
      );
      if (elements().phoneInput.getAttribute("aria-invalid") === "true")
        validatePhone();
    });
    elements().phoneInput.addEventListener("blur", () => {
      elements().phoneInput.value = formatPhoneNumber(
        elements().phoneInput.value
      );
      if (validatePhone()) {
        state.deliveryAddress.phone = elements().phoneInput.value;
        localStorage.setItem(
          CONFIG.storageKeys.deliveryAddress,
          JSON.stringify(state.deliveryAddress)
        );
      }
    });

    elements().nameInput.addEventListener("input", () => {
      if (elements().nameInput.getAttribute("aria-invalid") === "true")
        validateName();
    });

    elements().nameInput.addEventListener("blur", () => {
      if (validateName()) {
        state.deliveryAddress.name = elements().nameInput.value;
        localStorage.setItem(
          CONFIG.storageKeys.deliveryAddress,
          JSON.stringify(state.deliveryAddress)
        );
        document.getElementById("order_thanks_name").textContent =
          elements().nameInput.value;
      }
    });

    elements().areaInput.addEventListener("input", () => {
      if (elements().areaInput.getAttribute("aria-invalid") === "true")
        validateArea();
    });

    elements().areaInput.addEventListener("blur", () => {
      if (validateArea()) {
        state.deliveryAddress.area = elements().areaInput.value;
        localStorage.setItem(
          CONFIG.storageKeys.deliveryAddress,
          JSON.stringify(state.deliveryAddress)
        );
      }
    });
    // elements().mainPhoneVerifiyButton.addEventListener(
    //   "click",
    //   startPhoneVerification
    // );
    // --- Change listener for the city select ---

    elements().paymentRadios.forEach(radio => {
      radio.addEventListener('change', () => {
        if (validatePaymentMethod()) {
          state.paymentMethod = radio.value;
          localStorage.setItem(CONFIG.storageKeys.paymentMethod, state.paymentMethod);
          updateCheckoutButtonText();
        }
      });
    });

    // --- Click listener for the final checkout button ---
    elements().checkoutButton.addEventListener("click", handleCheckout);

    document.addEventListener("cart:updated", async (event) => {
      console.log("A cart update was detected!");
      //elements().deliveryCost = document.getElementById("delivery_cost");
      // Access the full cart data from the event's detail property
      const cart = event.detail.cart;

      // console.log("New item count:", cart.item_count);
      // console.log("Cart items:", cart.items);
      // console.log("Total price:", cart.total_price);

      //The below lines need review
      state.cartId = getCartId();
      await primeCartAndFetchOptions(); // 🚀 This is the key optimization
    });
    elements().exitButton.addEventListener("click", () => {
      window.location.href = routes.root_url;
    });
  };

  /**
   * Handles the final checkout button click. Validates all fields,
   * updates the cart with the final address, and redirects to checkout.
   */
  const rerunderTheCart = async () => {
    // Prefer nearby cart-items to reuse its sections definition if available
    const cartItems =
      document.querySelector("cart-items") ||
      document.querySelector("cart-drawer-items");

    const couponBox = document.querySelector("coupons-box");

    const sectionsToRender = cartItems?.getSectionsToRender
      ? cartItems.getSectionsToRender()
      : couponBox.getSectionsToRenderFallback();

    const body = JSON.stringify({
      sections: sectionsToRender.map((s) => s.section),
      sections_url: window.location.pathname,
    });

    const mainCart =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");

    const getSectionInnerHTML = (html, selector) => {
      return new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selector).innerHTML;
    };

    try {
      mainCart?.classList.add("cart__items--disabled");

      const response = await fetch(`${routes.cart_update_url}`, {
        ...fetchConfig(),
        body,
      });

      const stateText = await response.text();
      const parsedState = JSON.parse(stateText);

      // Re-render sections like CartItems.updateQuantity
      sectionsToRender.forEach((section) => {
        const mount =
          document
            .getElementById(section.id)
            ?.querySelector(section.selector) ||
          document.getElementById(section.id);
        if (mount && parsedState.sections?.[section.section]) {
          mount.innerHTML = getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        }
      });
      const domEvent = new CustomEvent("cart:updated", {
        bubbles: true,
        detail: {
          cart: parsedState, // We pass the entire cart object as the payload
        },
      });
      document.dispatchEvent(domEvent);
    } finally {
      mainCart?.classList.remove("cart__items--disabled");
    }
  };

  const handleCheckout = async () => {
    if (validateAll()) {
      setButtonState(true, "جاري الاعداد ...");
      await rerunderTheCart();
    }
    //console.log(state.matchedDeliveryOption);
    //open_orderThanksModal();
    //return;
    //localStorage.removeItem("__ui");
    if (!validateAll()) {
      setButtonState(false, "ارسال الطلب");
      const firstElementWithError = document.querySelector(".error-mark");
      if (firstElementWithError) {
        firstElementWithError.scrollIntoView({
          behavior: "smooth", // "auto" for instant
          block: "center", // "start" | "center" | "end" | "nearest"
          inline: "nearest",
        });
      }
      const elementsWithError = document.querySelectorAll(".error-pulse");
      console.log(elementsWithError);
      elementsWithError.forEach((element) => {
        element.classList.remove("error-pulse");
        element.classList.add("error-pulse-extra");
      });
      console.log("Validation failed.");
      return;
    }
    notifyInfo(`A customer clicked "send order" with valid cart and input
      ${elements().nameInput.value}
      ${elements().phoneInput.value}
      ${elements().citySelect.value}
      ${elements().areaInput.value}`);
    const { firstName, lastName } = splitFullName(elements().nameInput.value);
    if (!JodisoAuth.isAuthenticated()) {
      notifyInfo(`The following customer is not authenticated, authentication should start automatically now
      ${elements().nameInput.value}
      ${elements().phoneInput.value}
      ${elements().citySelect.value}
      ${elements().areaInput.value}`);
      const phoneVerificationResult = await startPhoneVerification(
        true,
        elements().phoneInput.value,
        firstName,
        lastName,
        CONFIG.country.phonePrefix
      );
      if (!phoneVerificationResult) {
        notifyInfo(`The following customer did not complete authentication
      ${elements().nameInput.value}
      ${elements().phoneInput.value}
      ${elements().citySelect.value}
      ${elements().areaInput.value}`);
        setButtonState(false, "ارسال الطلب");
        return;
      } else {
        notifyInfo(`The following customer completed authentication now, order should received in 30 seconds
      ${elements().nameInput.value}
      ${elements().phoneInput.value}
      ${elements().citySelect.value}
      ${elements().areaInput.value}`);
      }
    } else {
      console.log("Authenticated");
      notifyInfo(`The following customer is authenticated before clicking on "send order", order should received in 30 seconds
      ${elements().nameInput.value}
      ${elements().phoneInput.value}
      ${elements().citySelect.value}
      ${elements().areaInput.value}`);
    }
    // ============================================
    // Configuration
    // ============================================

    const CHECKOUT_CONFIG = {
      currency: "JOD",
      countryCode: "JO",
      retry: {
        maxAttempts: 3,
        baseDelayMs: 1000,
        backoffMultiplier: 2,
      },
      timeout: {
        default: 2000,
        webhook: 3000,
      },
    };

    // ============================================
    // Logger
    // ============================================

    const Logger = {
      info(message, data = null) {
        console.info(`[Checkout] ${message}`, data ?? "");
        notifyInfo(message);
      },
      warn(message, data = null) {
        console.warn(`[Checkout] ${message}`, data ?? "");
        notifyWarning(message);
      },
      error(message, error = null) {
        console.error(`[Checkout] ${message}`, error ?? "");
        notifyError(message);
      },
    };

    // ============================================
    // Fetch Utilities
    // ============================================

    class FetchError extends Error {
      constructor(message, { status, statusText, url } = {}) {
        super(message);
        this.name = "FetchError";
        this.status = status;
        this.statusText = statusText;
        this.url = url;
      }
    }

    const fetchWithTimeout = async (
      url,
      options = {},
      timeoutMs = CHECKOUT_CONFIG.timeout.default
    ) => {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), timeoutMs);

      try {
        const response = await fetch(url, {
          ...options,
          signal: controller.signal,
        });
        return response;
      } finally {
        clearTimeout(timeoutId);
      }
    };

    const fetchWithRetry = async (url, options = {}, config = {}) => {
      const {
        maxAttempts = CHECKOUT_CONFIG.retry.maxAttempts,
        baseDelayMs = CHECKOUT_CONFIG.retry.baseDelayMs,
        backoffMultiplier = CHECKOUT_CONFIG.retry.backoffMultiplier,
        timeoutMs = CHECKOUT_CONFIG.timeout.default,
      } = config;

      let lastError;

      for (let attempt = 1; attempt <= maxAttempts; attempt++) {
        try {
          const response = await fetchWithTimeout(url, options, timeoutMs);

          if (!response.ok) {
            throw new FetchError(
              `HTTP ${response.status}: ${response.statusText}`,
              {
                status: response.status,
                statusText: response.statusText,
                url,
              }
            );
          }

          return response;
        } catch (error) {
          lastError = error;
          const isLastAttempt = attempt === maxAttempts;
          const isAbortError = error.name === "AbortError";

          if (isAbortError) {
            Logger.warn(`Request timeout (attempt ${attempt}/${maxAttempts})`, {
              url,
            });
          } else {
            Logger.warn(
              `Request failed (attempt ${attempt}/${maxAttempts}): ${error.message}`
            );
          }

          if (!isLastAttempt) {
            const delay =
              baseDelayMs * Math.pow(backoffMultiplier, attempt - 1);
            await new Promise((resolve) => setTimeout(resolve, delay));
          }
        }
      }

      throw lastError;
    };

    // ============================================
    // Cart Service
    // ============================================

    const CartService = {
      // async fetch() {
      //   Logger.info("Fetching cart data...");

      //   const response = await fetchWithRetry("/cart", fetchConfig());
      //   const text = await response.text();
      //   return JSON.parse(text);
      // },

      transformItems(items) {
        return items
          .filter((item) => item.quantity > 0)
          .map((item) => ({
            variantId: `gid://shopify/ProductVariant/${item.id}`,
            quantity: item.quantity,
          }));
      },

      // extractApplicableDiscounts(discountCodes) {
      //   return discountCodes
      //     .filter((discount) => discount.applicable)
      //     .map((discount) => discount.code);
      // },

      buildShippingLine(deliveryCost, deliveryOption) {
        return {
          priceWithCurrency: {
            amount: deliveryCost,
            currencyCode: CHECKOUT_CONFIG.currency,
          },
          title: deliveryOption.title,
        };
      },

      async getFormattedCart(state) {
        //const rawCart = await this.fetch();
        const rawCart = {
          items: await JSON.parse(elements().cartItemsJson.textContent),
          discount_codes: await JSON.parse(
            elements().cartDiscountCodesJson.textContent
          ),
        };

        return {
          items: this.transformItems(rawCart.items),
          discountCodes: rawCart.discount_codes,
          shippingLine: this.buildShippingLine(
            state.deliveryCost,
            state.matchedDeliveryOption
          ),
        };
      },

      async clear() {
        Logger.info("Clearing cart...");
        await fetchWithRetry("/cart/clear", fetchConfig());
        Logger.info("Cart cleared successfully");
      },
    };

    // ============================================
    // Address Service
    // ============================================

    const AddressService = {
      formatPhoneNumber(phoneInput, phonePrefix) {
        const localNumber = phoneInput.startsWith("0")
          ? phoneInput.substring(1)
          : phoneInput;
        return `+${phonePrefix}${localNumber}`;
      },

      buildShippingAddress(firstName, lastName) {
        return {
          firstName,
          lastName,
          address1: elements().areaInput.value,
          city: elements().citySelect.value,
          phone: this.formatPhoneNumber(
            elements().phoneInput.value,
            CONFIG.country.phonePrefix
          ),
          countryCode: CHECKOUT_CONFIG.countryCode,
        };
      },
    };

    // ============================================
    // Analytics Service
    // ============================================

    const AnalyticsService = {
      publishCheckoutCompleted(subtotalCost, discountCodes) {
        const eventData = {
          checkout: {
            subtotalPrice: subtotalCost / 100,
            currencyCode: CHECKOUT_CONFIG.currency,
            discountCodes: discountCodes.join(", "),
          },
        };

        Shopify.analytics.publish("JODISO:checkout_completed", eventData);
        Logger.info("Checkout completed event published", eventData);
      },
    };

    // ============================================
    // Order Service
    // ============================================

    const OrderService = {
      buildPayload(cart, shippingAddress) {
        return {
          lineItems: cart.items,
          shippingAddress: shippingAddress,
          shippingLine: cart.shippingLine,
          discountCodes: cart.discountCodes,
          acceptAutomaticDiscounts: true,
        };
      },

      async submit(payload, paymentMethod) {
        Logger.info(`Submitting order via ${paymentMethod} endpoint...`);

        let response;
        if (paymentMethod === "cod") {
          response = await JodisoAuth.createManualPaymentOrder({ ...payload, paymentTermsTemplateId: "gid://shopify/PaymentTermsTemplate/1" });
        } else if (paymentMethod === "electronic") {
          response = await JodisoAuth.createOnlinePaymentOrder(payload);
        } else {
          throw new Error("طريقة الدفع غير صالحة");
        }

        if (!response.success || (response.data && !response.data.success)) {
          throw new Error(response.error || (response.data && response.data.message) || "فشل تنفيذ الطلب");
        }

        (paymentMethod == "cod") ? Logger.info("COD Order submitted successfully") : Logger.info("Electronic draft order submitted and waiting for payment");
        return response.data;
      },
    };

    // ============================================
    // Checkout Orchestrator
    // ============================================

    const CheckoutOrchestrator = {
      async execute(state, firstName, lastName) {
        try {
          Logger.info("Starting checkout process...");
          open_processingModal(state.paymentMethod);

          const cart = await CartService.getFormattedCart(state);
          const shippingAddress = AddressService.buildShippingAddress(
            firstName,
            lastName
          );

          const payload = OrderService.buildPayload(
            cart,
            shippingAddress
          );

          const responseData = await OrderService.submit(payload, state.paymentMethod);

          const subtotalCost =
            +elements().subtotalCost.getAttribute("data-subtotal-cost");
          state.paymentMethod == "cod" ? AnalyticsService.publishCheckoutCompleted(
            subtotalCost,
            cart.discountCodes
          ) : null;

          (state.paymentMethod === "cod") ? await CartService.clear() : null;

          state.paymentMethod == "cod" ? Logger.info("Checkout completed successfully!") : null;

          if (state.paymentMethod === "cod") {
            show_successState();
          } else if (state.paymentMethod === "electronic") {
            if (responseData.order && responseData.order.invoiceUrl) {
              window.location.href = responseData.order.invoiceUrl;
            } else {
              throw new Error("لم يتم العثور على رابط الفاتورة خطأ غير متوقع");
            }
          }

          return { success: true };
        } catch (error) {
          Logger.error(`Checkout failed: ${error.message}`, error);
          setButtonState(false, state.paymentMethod === "cod" ? "ارسال الطلب" : "المتابعة للدفع");
          show_errorState();
          return { success: false, error };
        }
      },
    };

    // ============================================
    // Usage
    // ============================================

    await CheckoutOrchestrator.execute(state, firstName, lastName);

    /*
    setButtonState(true, "جاري الاعداد ...");

    state.cartId = getCartId();

    // Step 1: Check for an existing address on the cart.
    state.cartState = await callShopifyApi(CONFIG.queries.initialCartQuery, {
      cartId: state.cartId,
    });

    let selectedAddress = state.cartState?.data?.cart?.delivery?.addresses[0];
    state.deliveryAddressId = selectedAddress.id;
    if (!state.deliveryAddressId) {
      elements().deliveryCost.textContent = "حدث خطأ ما";
      setButtonState(true, "حدث خطأ ما");
      console.error("Failed to obtain a valid deliveryAddressId for the cart.");
      return;
    }


    const deliveryGroup = state.cartState?.data?.cart?.deliveryGroups?.nodes[0];

    if (deliveryGroup?.deliveryOptions?.length) {
      state.allDeliveryOptions = deliveryGroup.deliveryOptions;
      state.deliveryGroupId = deliveryGroup.id;
    } else {
      elements().deliveryCost.textContent = "حدث خطأ ما";
      setButtonState(true, "حدث خطأ ما");
      console.error("Failed to fetch delivery options for the cart.");
      return;
    }
    UpdateMatchedDeliveryOption();
    // Guard against missing state from initialization phase
    if (!state.deliveryAddressId || !state.deliveryGroupId) {
      alert("Initialization failed. Please refresh the page and try again.");
      setButtonState(false, "ارسال الطلب");
      return;
    }
    const updateBuyerIdentityResponse = await callShopifyApi(
      CONFIG.queries.cartBuyerIdentityUpdate,
      {
        cartId: state.cartId,
        phone:
          CONFIG.country.phonePrefix + elements().phoneInput.value.substring(1),
      }
    );
    // Prepare name fields
    const nameParts = elements().nameInput.value.trim().split(/\s+/);
    const firstName = nameParts.shift() || "";
    const lastName = nameParts.join(" ") || "-";

    const finalAddressVariables = {
      cartId: state.cartId,
      firstName,
      lastName,
      address1: elements().areaInput.value,
      city: elements().citySelect.value,
      zip: "0", // Shopify often requires a ZIP, even if not used locally
      phone:
        CONFIG.country.phonePrefix + elements().phoneInput.value.substring(1),
      addressId: state.deliveryAddressId,
    };

    const addAddressResponse = await callShopifyApi(
      CONFIG.queries.cartDeliveryAddressUpdate,
      finalAddressVariables
    );
    const updateDeliveryOptionsResponse = await callShopifyApi(
      CONFIG.queries.cartSelectedDeliveryOptionsUpdate,
      {
        cartId: state.cartId,
        deliveryGroupId: state.deliveryGroupId,
        deliveryOptionHandle: state.matchedDeliveryOption.handle,
      }
    );
    if (
      updateBuyerIdentityResponse &&
      updateBuyerIdentityResponse.data?.cartBuyerIdentityUpdate?.cart
        ?.checkoutUrl
    ) {
      // window.location.href =
      //   updateBuyerIdentityResponse.data?.cartBuyerIdentityUpdate?.cart
      //     ?.checkoutUrl;
    } else {
      alert("Could not retrieve checkout URL. Please try again.");
      setButtonState(false, "ارسال الطلب");
    }*/
  };

  /**
   * Initializes the delivery session. This is the core of the optimization.
   * It "primes" the cart with a country context, then fetches and caches
   * all available delivery options for that country.
   */

  const primeCartAndFetchOptions = async () => {
    setupEventListenersForRerenderedElements();
    loadInitialAddress();
    populateFormFields();
    //The below line helps to get fresh checkout
    //localStorage.removeItem("__ui");
    /*
    state.isInitializing = true;
    setButtonState(true, "جاري الاعداد ...");
    elements().deliveryCost.textContent = "يتم الاحتساب ...";

    // Step 1: Check for an existing address on the cart.
    state.cartState = await callShopifyApi(CONFIG.queries.initialCartQuery, {
      cartId: state.cartId,
    });
    if (state.cartState?.data?.cart?.totalQuantity === 0) {
      console.log("No items in the cart");
    } else {
      let selectedAddress = state.cartState?.data?.cart?.delivery?.addresses[0];
      if (
        selectedAddress &&
        selectedAddress.address.countryCode === CONFIG.country.code
      ) {
        // Address exists and is correct. Store its ID.
        state.deliveryAddressId = selectedAddress.id;
      } else {
        // No address, or wrong country. Add/update one to set the JO context.
        const response = selectedAddress?.id
          ? // If address exists but has wrong country, update it.
            await callShopifyApi(CONFIG.queries.cartDeliveryAddressUpdate, {
              cartId: state.cartId,
              addressId: selectedAddress.id,
            })
          : // If no address exists, add a new one.
            await callShopifyApi(CONFIG.queries.cartDeliveryAddressesAdd, {
              cartId: state.cartId,
            });

        if (response?.userErrors?.length) {
          console.error(
            "Could not prime cart with address:",
            response.userErrors
          );
        }
        // Re-fetch the cart state to get the ID of the new/updated address.
        state.cartState = await callShopifyApi(
          CONFIG.queries.initialCartQuery,
          {
            cartId: state.cartId,
          }
        );
        state.deliveryAddressId =
          state.cartState?.data?.cart?.delivery?.addresses[0]?.id;
      }

      // Guard: Ensure we have a deliveryAddressId before proceeding.
      if (!state.deliveryAddressId) {
        elements().deliveryCost.textContent = "حدث خطأ ما";
        setButtonState(true, "حدث خطأ ما");
        console.error(
          "Failed to obtain a valid deliveryAddressId for the cart."
        );
        return;
      }

      const deliveryGroup =
        state.cartState?.data?.cart?.deliveryGroups?.nodes[0];

      if (deliveryGroup?.deliveryOptions?.length) {
        state.allDeliveryOptions = deliveryGroup.deliveryOptions;
        state.deliveryGroupId = deliveryGroup.id;
        console.log(state.allDeliveryOptions);
      } else {
        elements().deliveryCost.textContent = "حدث خطأ ما";
        setButtonState(true, "حدث خطأ ما");
        console.error("Failed to fetch delivery options for the cart.");
        return;
      }

      // Step 3: Finalize initialization.
      state.isInitializing = false;
      setButtonState(false, "ارسال الطلب");
      
      updateDeliveryCostUI();
    }*/
    state.isInitializing = false;
    updateDeliveryCostUI();
  };

  /**
   * Main function to start the application.
   */
  const main = () => {
    state.cartId = getCartId();
    if (!state.cartId) {
      alert(
        "Could not identify your shopping cart. Please refresh the page or add an item to your cart."
      );
      return;
    }

    setupEventListenersForStaticElements();
    primeCartAndFetchOptions(); // 🚀 This is the key optimization
  };

  // Run the application.
  main();
});
